import React from "react";

type Props = {
    className?: string;
};

export default function GreenCheck(props: Props) {
    return (
        <svg
            className={props.className}
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 18 18"
        >
            <g fill="none" fillRule="evenodd">
                <g>
                    <g transform="translate(-347 -520) translate(347 520)">
                        <circle cx="9" cy="9" r="9" fill="#00D065" />
                        <g stroke="#FFF">
                            <path
                                d="M1 1l5.338 6.068 2.978-2.534"
                                transform="translate(4 5) scale(-1 1) rotate(-4 0 151.746)"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
